"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function AddBookingForm({ roomId }: { roomId: number }) {
  const router = useRouter();

  // datetime-local waarde is: "YYYY-MM-DDTHH:mm"
  const [startLocal, setStartLocal] = useState("");
  const [endLocal, setEndLocal] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setIsSaving(true);

    try {
      const apiUrl = process.env.NEXT_PUBLIC_API_URL;
      if (!apiUrl) throw new Error("NEXT_PUBLIC_API_URL is niet gezet.");

      if (!startLocal || !endLocal) {
        throw new Error("Start en eindtijd zijn verplicht.");
      }

      const start = new Date(startLocal);
      const end = new Date(endLocal);

      if (!(end > start)) {
        throw new Error("Eindtijd moet na starttijd liggen.");
      }

      const res = await fetch(`${apiUrl}/rooms/${roomId}/bookings`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          start_time: start.toISOString(),
          end_time: end.toISOString(),
        }),
      });

      if (res.status === 409) {
        throw new Error("Deze booking overlapt met een bestaande booking.");
      }
      if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `API error: ${res.status}`);
      }

      setStartLocal("");
      setEndLocal("");
      setSuccess("Booking opgeslagen!");
      router.refresh();
    } catch (err: any) {
      setError(err?.message ?? "Onbekende fout");
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <form onSubmit={onSubmit} style={{ display: "grid", gap: 12, maxWidth: 520 }}>
      <h2>Add booking</h2>

      <label style={{ display: "grid", gap: 6 }}>
        <span>Start</span>
        <input
          type="datetime-local"
          value={startLocal}
          onChange={(e) => setStartLocal(e.target.value)}
          required
          style={{ padding: 8 }}
        />
      </label>

      <label style={{ display: "grid", gap: 6 }}>
        <span>Einde</span>
        <input
          type="datetime-local"
          value={endLocal}
          onChange={(e) => setEndLocal(e.target.value)}
          required
          style={{ padding: 8 }}
        />
      </label>

      <button type="submit" disabled={isSaving} style={{ padding: 10 }}>
        {isSaving ? "Opslaan…" : "Add booking"}
      </button>

      {error && <p style={{ color: "crimson" }}>{error}</p>}
      {success && <p style={{ color: "green" }}>{success}</p>}
    </form>
  );
}
